import { render, staticRenderFns } from "./respuestasForo.vue?vue&type=template&id=758dc32a"
import script from "./respuestasForo.vue?vue&type=script&lang=js"
export * from "./respuestasForo.vue?vue&type=script&lang=js"
import style0 from "./respuestasForo.vue?vue&type=style&index=0&id=758dc32a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports